export default "__VITE_ASSET__a1a0a044__"